import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useReveal } from "@/lib/motion";
import { FOUNDER, CTA } from "@/lib/siteData";

export const Founder = () => {
    const reveal = useReveal();

    return (
        <section>
            <div className="relative min-h-[420px] md:min-h-[460px] lg:min-h-[480px] overflow-hidden bg-ink">
                <img
                    src={FOUNDER.photo}
                    alt={`${FOUNDER.name}, ${FOUNDER.homeTitle}`}
                    className="absolute inset-0 h-full w-full object-cover grayscale"
                    style={{ objectPosition: "center 54%" }}
                />

                {/* Gradient overlay for optimal legibility of white text on left and right */}
                <div
                    aria-hidden
                    className="absolute inset-0 bg-gradient-to-r from-ink/75 via-ink/25 to-ink/65 md:from-ink/70 md:via-transparent md:to-ink/55"
                />

                <div className="relative mx-auto flex max-w-[1440px] flex-col justify-between gap-10 px-6 py-10 md:min-h-[460px] lg:min-h-[480px] md:flex-row md:items-end md:px-12 md:pb-10 md:pt-12 lg:px-16 lg:pb-12 lg:pt-14">
                    {/* Left: 3 Editorial Paragraphs (centered vertically on desktop) */}
                    <div className="max-w-[360px] space-y-4 text-[clamp(14px,1.15vw,16px)] font-light leading-relaxed text-paper md:self-center">
                        {FOUNDER.homeParagraphs.map((paragraph, index) => (
                            <motion.p key={index} {...reveal(index * 0.08)}>
                                {paragraph}
                            </motion.p>
                        ))}
                    </div>

                    {/* Right: Founder Name, Title, and Saiba Mais Button in bottom-right corner */}
                    <motion.div
                        className="flex flex-col items-center text-center md:items-end md:self-end md:text-right"
                        {...reveal(0.24)}
                    >
                        <h3 className="type-display text-[clamp(30px,3.2vw,44px)] font-bold uppercase leading-tight tracking-tight text-paper">
                            {FOUNDER.name}
                        </h3>
                        <p className="mt-1 text-[clamp(15px,1.35vw,19px)] font-light text-paper/90">
                            {FOUNDER.homeTitle}
                        </p>
                        <Link
                            to="/sobre/andre"
                            className="type-display mt-5 inline-flex h-[46px] w-[190px] items-center justify-center bg-paper text-[19px] font-bold text-brand shadow-sm transition-all duration-300 btn-sweep [--sweep:theme(colors.brand.DEFAULT/12%)] md:text-[21px]"
                        >
                            Saiba Mais
                        </Link>
                    </motion.div>
                </div>
            </div>

            {/* Closing CTA */}
            <div className="bg-paper px-6 pb-[95px] pt-[71px] text-center">
                <motion.h2
                    className="type-display mx-auto max-w-[785px] text-[clamp(30px,3.8vw,55px)] text-brand"
                    {...reveal()}
                >
                    {CTA.menu.headline}
                </motion.h2>
                <motion.p
                    className="mx-auto mt-4 max-w-[617px] text-[clamp(16px,1.7vw,24px)] text-ink"
                    {...reveal(0.08)}
                >
                    {CTA.menu.subhead[0]}
                    <strong className="font-bold">{CTA.menu.subhead[1]}</strong>
                </motion.p>
                <motion.div className="mt-[52px]" {...reveal(0.16)}>
                    <Link
                        to="/contato"
                        className="type-display inline-flex h-[50px] w-[269px] items-center justify-center bg-brand text-action text-paper btn-sweep [--sweep:theme(colors.brand.deep)]"
                    >
                        {CTA.menu.action}
                    </Link>
                </motion.div>
            </div>
        </section>
    );
};

